"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Spinner = function Spinner(_ref) {
  var loading = _ref.loading,
    spinner = _ref.spinner,
    processing = _ref.processing;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'spinner ' + (loading || processing ? '' : 'hidden'),
    alt: "Loading..."
  }, spinner);
};
Spinner.propTypes = {
  loading: _propTypes.default.bool.isRequired,
  processing: _propTypes.default.bool.isRequired,
  spinner: _propTypes.default.element.isRequired
};
var _default = Spinner;
exports.default = _default;